import 'bootstrap/dist/css/bootstrap.min.css';
import '../sass/app.scss';

require('./modules/lazy-load');
require('./modules/mega-menu');
require('./modules/owl-carousel');
require('./modules/frontend');
require('./modules/forms');
